import { render, staticRenderFns } from "./shopAttention.vue?vue&type=template&id=f79c409e&scoped=true"
import script from "./shopAttention.vue?vue&type=script&lang=js"
export * from "./shopAttention.vue?vue&type=script&lang=js"
import style0 from "./shopAttention.vue?vue&type=style&index=0&id=f79c409e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79c409e",
  null
  
)

export default component.exports